import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const fetchStores = (params = {}) =>
    client.get("/stores", { params }).then((r) => r.data);

export const fetchStore = (slug) =>
    client.get(`/stores/${slug}`).then((r) => r.data);

export const fetchProducts = (params = {}) =>
    client.get("/products", { params }).then((r) => r.data);

export const fetchProduct = (storeSlug, productSlug) =>
    client.get(`/products/${storeSlug}/${productSlug}`).then((r) => r.data);

export const fetchCategories = () =>
    client.get("/categories").then((r) => r.data);

export const search = (q) =>
    client.get("/search", { params: { q } }).then((r) => r.data);
